import { ReactElement, useState } from 'react'

import {
  ChatDrawer,
  HistoryModalContainer,
  VirtualAssistantChatContextProvider,
  type VirtualAssistantChatPanelState,
  VirtualAssistantHost,
} from '@features/virtualAssistant'

import { DrawerBorderRadiusSync } from '../GlobalApplication/DrawerBorderRadiusSync'
import { EmberViewSqueezeSync } from '../GlobalApplication/EmberViewSqueezeSync'

const closedChatPanel: VirtualAssistantChatPanelState = { isExpanded: false, isOpen: false }

export const GlobalVirtualAssistant = (): ReactElement => {
  const [chatPanelState, setChatPanelState] = useState<VirtualAssistantChatPanelState>(closedChatPanel)

  return (
    <>
      <DrawerBorderRadiusSync chatPanelState={chatPanelState} />
      <VirtualAssistantHost onChatPanelChange={setChatPanelState}>
        <VirtualAssistantChatContextProvider>
          <EmberViewSqueezeSync chatPanelState={chatPanelState} />
          <ChatDrawer />
          <HistoryModalContainer />
        </VirtualAssistantChatContextProvider>
      </VirtualAssistantHost>
    </>
  )
}
